<template>

<div class="schedule">

    <app-icon icon="loading" v-if="is.loading && !is.initialised" class="schedule-loading" />

    <template v-if="is.initialised">

        <com-filter :filter="filter" :references="references" />

        <app-events v-on:hide="load" :no-click="true" :is-inline="true" :loading="is.loading && is.initialised" :filter="filter" :collection="collection" :columns="columns" :pagination="pagination" :total="total" placeholder="Sorry, no events found." v-on:scrolled="onScrollLoad" v-on:paged="onPaged" />

    </template>

</div>
	
</template>

<script>

import mixCollection from '@/mixin/collection'
import comFilter from './schedule/Filter'

export default {

	mixins: [mixCollection],

    components: {
        'com-filter': comFilter
    },

	props: ['item'],

    data: function() {

		return {
            inline: true,
			scrolling: false,
			endpoint: '../register/block/schedule',
			filter: {
                search: '',
                sort: 'start'
			},
            params: {
                block: false
            },
			columns: {
				game: 300,
				seats: 140,
				date: 200,
				experience: 100,
				duration: 80,
				location: 'auto'
			}
		}

	},

    methods: {

        setupParams: function() {

            this.params.block = this.item.id

        }
    
    }

}

</script>

<style scoped>

.schedule {
    height: auto;
    padding: 0px;
    margin: 20px;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: hidden;
    min-height: 100px;
}

.schedule >>> .body {
    padding: 0px!important;
}

.schedule-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    font-size: 32px;
    color: #ffbe7a;
    margin-top: -32px;
    margin-left: -32px;
}

</style>